import { useUserStore } from '@/vue/stores/user';
import { usePermissionsStore } from '../../../../vue/stores/permissions';
import ROUTE_NAMES from '../../../../vue/routes/routeNames';

export const getPermittedHomeRoute = (): string|null => {
    const { allPermissions } = usePermissionsStore();
    const userStore = useUserStore();

    const homeRoutes = [
        { permission: allPermissions.generalHome, name: ROUTE_NAMES.HOME },
        { permission: allPermissions.monitoring, name: ROUTE_NAMES.OBSERVE_MAIN },
        { permission: allPermissions.review, name: ROUTE_NAMES.REVIEW_LIST },
        { permission: allPermissions.schedule, name: ROUTE_NAMES.SCHEDULE_MAIN },
        { permission: allPermissions.reports, name: ROUTE_NAMES.REPORT_LIST },
        { permission: allPermissions.admin, name: ROUTE_NAMES.ADMIN_MAIN },
    ];

    const permittedRoutes = homeRoutes
        .filter((route) => userStore.hasPermission(route.permission))
        .map((route) => route.name);

    return permittedRoutes.shift() ?? null;
};
